import { useEffect } from "react";
import { MONTHLY } from "../../constans";
import { BACKEND_URL } from "../../services/contants";
import { useNavigate } from "react-router-dom";
import { setSerial } from "../../services/firestore";
const paypalClientId =
    "AXQr4wmnKi-xxPe76qVFHiuXEyR1jqdfR9XIkMf8vSk4w5oDRjDGMmFugPEUcp0qwmmBr-ngrq3UKXph";
const MONTHLY_PLAN_ID = "P-5A0536474N404924HNEIVMCA"
const ANNUAL_PLAN_ID = "P-2MR00784M89100927NEIWW2I"

export const usePaypal = ({ plan, email, password, onLoad }) => {
    const navigate = useNavigate();
    useEffect(() => {
        if (document.getElementById("paypal-sdk")) return;

        const script = document.createElement("script");

        script.id = "paypal-sdk";
script.src =
  `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&vault=true&intent=subscription`;
        script.addEventListener("load", () => {
            if (window.paypal) {
                window.paypal.Buttons({
                    fundingSource: window.paypal.FUNDING.PAYPAL,
                    style: { layout: "vertical", color: "gold", shape: "rect", label: "subscribe" },

                    createSubscription: function (data, actions) {
                        return actions.subscription.create({
                            plan_id: plan == MONTHLY ? MONTHLY_PLAN_ID : ANNUAL_PLAN_ID, // from PayPal dashboard
                        });
                    },

                    onApprove: function (data, actions) {
                        // Send subscriptionID to your backend for verification
                        console.log("subscription approved")
                        fetch(`${BACKEND_URL}/paypal/create-subscription`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                subscriptionID: data.subscriptionID,
                                planId: plan == MONTHLY ? MONTHLY_PLAN_ID : ANNUAL_PLAN_ID,
                                email: email,
                            }),
                        })
                            .then((res) => res.json())
                            .then((result) => {
                                if (result.success) {
                                    navigate('/registration_complete')
                                    
                                }
                                console.log("Backend verification result:", result)
                            })
                            .catch((err) => console.error(err));
                    },

                    onError: function (err) {
                        console.error("PayPal Button Error:", err);
                    },
                }).render("#paypal-button-container");

            }
        });
        document.body.appendChild(script);
        onLoad && onLoad()
    }, []);
}